<template>
    <!--个人中心-->
    <div class="personal">
        <div class="tab">
            <div class="left">
                <div class="leftBox" :class="{chooseTop:isChoose}">
                    <div class="avatar">
                        <i class="iconfont" v-show="headimgurl === ''">&#xe774;</i>
                        <img width="100%" :src="headimgurl" alt="">
                        <input type="file" accept="image/*" name="file" @change.self="changeHead($event)"/>
                    </div>
                    <ul>
                        <li v-for="(tab,index) in tabs" :class="{active:curNav === tab.id}" @click="
                    changeTab(tab)" :key="index">
                            <span v-text="tab.value"></span>
                            <i class="iconfont" v-html="tab.icon"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="right">
                <!--<component :is="tabView"></component>-->
                <PersonalData v-show="curNav === '0'"></PersonalData>
                <MyCollection v-show="curNav === '1'"></MyCollection>
                <!--&lt;!&ndash;<Entrust v-show="curNav === 2 || curNav === 3 || curNav === 4 || curNav === 5"></Entrust>&ndash;&gt;-->
                <Entrust1 v-show="curNav === '2'"></Entrust1>
                <Entrust2 v-show="curNav === '3'"></Entrust2>
                <Entrust3 v-show="curNav === '4'"></Entrust3>
                <Entrust4 v-show="curNav === '5'"></Entrust4>
                <myAuction v-show="curNav === '6'"></myAuction>
                <myRemind v-show="curNav === '7'"></myRemind>
                <AccountCancellate v-show="curNav === '8'"></AccountCancellate>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import axios from 'axios'
	import PersonalData from "../personalData/PersonalData";
	import MyCollection from "../personalData/MyCollection";
	import AccountCancellate from "../personalData/AccountCancellate";
	import Entrust1 from "../personalData/Entrust1";
	import Entrust2 from "../personalData/Entrust2";
	import Entrust3 from "../personalData/Entrust3";
	import Entrust4 from "../personalData/Entrust4";
	import myAuction from '../personalData/myAuction'
	import myRemind from '../personalData/myRemind'
	import {isLogin, editHeadimgurl} from '../../api/index'
	import {meInfo} from '../../apiNew/index'

	export default {
		data() {
			return {
				toTop: '返回顶部',
				erweima: '',
				erweimaName: '',
				upload: false,
				isChoose: false,
				tabView: 'select0',
				tabs: [{id: '0', value: '个人资料', icon: '&#xe60a;'}, {id: '1', value: '我的收藏', icon: '&#xe60a;'},
					{id: '2', value: '我要卖房', icon: '&#xe60a;'}, {id: '3', value: '我要出租', icon: '&#xe60a;'},
					{id: '4', value: '我要买房', icon: '&#xe60a;'}, {id: '5', value: '我要租房', icon: '&#xe60a;'},
					{id: '6', value: '我的竞拍', icon: '&#xe60a;'}, {id: '7', value: '我的订阅', icon: '&#xe60a;'},
					{id: '8', value: '账户注销', icon: '&#xe60a;'}],
				curNav: '0',
				headimgurl: '',
				productImgs: [],
				isMultiple: true,
				file: '',
				isShow: '',
				token: '',
			}
		},
		components: {
			PersonalData,
			MyCollection,
			Entrust1,// 卖房
			Entrust2,// 出租
			Entrust3,// 卖房
			Entrust4,// 租房
			myAuction,// 我的拍卖
			myRemind,// 我的提醒
			AccountCancellate,
		},
		created() {
			window.addEventListener('setItem', () => {
				// console.log(localStorage.getItem('personalIndex'))
				this.curNav = localStorage.getItem('personalIndex')
				// this.$router.push({path: '/personal/' + this.curNav})
			})
		},
		mounted() {
			// console.log(localStorage.getItem('personalIndex'))
			this.headimgurl = JSON.parse(localStorage.getItem('userInfo')).headimgurl
			this.curNav = localStorage.getItem('personalIndex')
			this.init()
		},
		methods: {
			init() {
				if (localStorage.getItem('isLogin') === undefined || localStorage.getItem('isLogin') === '0') {
					this.$router.push({name: 'home'})
				}
				if (localStorage.getItem('isLogin') === '1') {
					this.token = localStorage.getItem('token')
				}
			},
			//上传图片
			changeHead() {
				let _this = this
				_this.file = event.target.files[0];
				let formdata = new FormData();
				formdata.append('file', _this.file);
				formdata.append("bucket", "jlhpm");
				axios.post("https://upload.iov.me/qiniu.php", formdata, {
					headers: {"Content-Type": "multipart/form-data"},
					withCredentials: true
				}).then(function (res) {
					_this.headimgurl = res.data.data
					_this.isChooseAvatar = 1
					editHeadimgurl({
						headimgurl: _this.headimgurl,
						token: _this.token
					}).then(res => {
						_this.$message({
							message: res.msg,
							type: 'warning'
						})
						meInfo({
							token: localStorage.getItem('token')
						}).then(ress => {
							// console.log(ress)
							localStorage.setItem('isLogin', '1');
							localStorage.setItem('userInfo', JSON.stringify(ress.data));
						}).catch(err => {
							localStorage.setItem('isLogin', '0');
							this.$message({
								message: err.message,
								timeout: 1500,
							});
						})
					}).catch(err => {
						_this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				}).catch(err => {
					console.log(err)
					_this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			changeTab: function (tab) {
				this.curNav = tab.id
				this.$router.push('/personal/' + tab.id)
				this.$addStorageEvent('personalIndex', tab.id)
			},
		},
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .personal {
        height: 100%;
        background: #f5f5f5;
        .top_nav {
            background: #000;
        }
        .tab {
            width: 1200px;
            min-width: 1200px;
            display: flex;
            margin: 0 auto;
            padding: 120px 0 80px;
            position: relative;
            .left {
                width: 21.66667%;
                box-sizing: border-box;
                border-right: 1px solid #e6e6e6;
                background: #fff;
                padding: 70px 0 0;
                min-height: 486px;
                .leftBox {
                    width: 260px;
                    /*position :fixed;*/
                    /*top :170px;*/
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    &.chooseTop {
                        top: 100px;
                    }
                    .avatar {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        box-sizing: border-box;
                        background: #FFF3E8;
                        border: 1px solid #FFE6CC;
                        border-radius: 50%;
                        overflow: hidden;
                        i {
                            position: absolute;
                            bottom: -5px;
                            left: 50%;
                            transform: translateX(-50%);
                            font-size: 89px;
                            color: #FFB267;
                        }
                        input {
                            opacity: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            cursor: pointer;
                        }
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    ul {
                        width: 260px;
                        text-align: center;
                        padding: 62px 0 0;
                        min-height: 500px;
                        li {
                            position: relative;
                            display: flex;
                            justify-content: center;
                            /*margin-top: 40px;*/
                            color: #666;
                            line-height: 60px;
                            font-size: 16px;
                            cursor: pointer;
                            i {
                                font-size: 12px;
                                color: #fff;
                                margin-left: 12px;
                            }
                        }
                        li.active {
                            color: #FFAE01;
                            i {
                                color: #FFAE01;
                            }
                        }
                    }
                }
            }
            .right {
                flex: 1;
                /*margin-left: 21.66667%;*/
                padding: 60px;
                background: #fff;
            }
        }
    }

</style>